import { render } from "./bonusPayments.vue?vue&type=template&id=6573f23c&ts=true"
import script from "./bonusPayments.vue?vue&type=script&lang=ts"
export * from "./bonusPayments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__